module.exports = __webpack_public_path__ + "static/media/SangBae_Profile.7a42d229.pdf";